import React, {useState, useEffect, useContext, useRef} from 'react';
import { useParams } from "react-router-dom";

import { DataContext } from 'contexts/DataContext';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';

import Forum from '@mui/icons-material/Forum';
import AssessmentNavigator from 'components/AssessmentNavigator/AssessmentNavigator';
import AssessmentControl from 'components/AssessmentControl/AssessmentControl';

import "i18n/config"
import { useTranslation } from 'react-i18next';

import { getControl, update, exportQuestionnaire } from './api';
import { getCategories } from 'components/AssessmentNavigator/api';

import SubcategoryApproval from 'components/SubcategoryApproval/SubcategoryApproval';

import fileDownload from 'js-file-download';
import moment from 'moment';
import { Search } from '@mui/icons-material';

function Questionnaire() {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const [saving, setSaving] = useState(false);
  const [exporting, setExporting] = useState(false); //eslint-disable-line

  const [currentControl, setCurrentControl] = useState({} as any);
  const [currentControls, setCurrentControls] = useState({} as any);
  const [currentCategory, setCurrentCategory] = useState('');
  const [currentSubcategory, setCurrentSubcategory] = useState('');
  const [loadControl, setLoadControl] = useState({} as any);
  const [categories, setCategories] = useState([] as any);
  const [reloadNavigator, setReloadNavigator] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  
  const formRef = useRef<HTMLFormElement>(null);
  const { id_control, id_category, id_subcategory } = useParams();

  //Load control from url params
  useEffect(() => {
    let control = {id_control: id_control, id_category: id_category, id_subcategory: id_subcategory};
    setLoadControl(control);
  },[id_control, id_category, id_subcategory]);

  useEffect(() => {
    if(dataContext.loading) return;
    if(!dataContext.currentAssessment) return;
    dataContext.changeShowLoader(true);
    getCategories(dataContext.currentAssessment).then((response) => {
      setCategories(response);

      let loadIdControl = dataContext.currentControl.id_control;
      let loadCategory = dataContext.currentControl.id_category;
      let loadSubcategory = dataContext.currentControl.id_subcategory;

      if(currentCategory) {
        loadCategory = currentCategory;
      }
    
      if(currentSubcategory) {
        loadCategory = currentCategory;
        loadSubcategory = currentSubcategory;
      }
      
      if(loadControl.id_control) {
        loadIdControl = loadControl.id_control;
        loadCategory = loadControl.id_category;
        loadSubcategory = loadControl.id_subcategory;
      }

      getControl(
        dataContext.currentAssessment, 
        loadCategory,
        loadSubcategory,
        loadIdControl
        ).then((response) => {
        dataContext.changeCurrentControl(response.control);
        setCurrentControl(response.control);
        //Navigation controls
        setCurrentControls(response.controls);
        dataContext.changeShowLoader(false);
      }).catch((error) => {
        dataContext.changeCurrentControl('');
        setLoadControl('');
      });

    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataContext.loading, dataContext.currentAssessment, loadControl, currentCategory, currentSubcategory]);


  useEffect(() => {
    if(!reloadNavigator) return;
    getCategories(dataContext.currentAssessment).then((response) => {
      setCategories(response);
      setReloadNavigator(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadNavigator]);


  const selectCategory = (category: string) => {
      if(category !== currentCategory) {
        setCurrentCategory(category);
        //Empty subcategory and control to load new category
        setCurrentSubcategory('');
        setLoadControl('');
        dataContext.changeCurrentControl('');
     }
  }

  const selectSubcategory = (subcategory: string) => {
      setCurrentCategory(dataContext.currentControl.id_category);
      setCurrentSubcategory(subcategory);
      //Empty control to load new subcategory
      setLoadControl('');
      dataContext.changeCurrentControl('');
  }

  const selectControl = (control: any) => {
      //Set control to load
      setLoadControl(control);
      //Save to context
      dataContext.changeCurrentControl(control);
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {


let gotoNext = event.currentTarget.getAttribute('gotoNext');

    dataContext.changeShowLoader(true);
    setSaving(true);
    const data = new FormData(event.currentTarget);
    update(currentControl.id,data).then((response) => {

      if(gotoNext==='1') {
        //find index of next control
        let currentControlIndex = currentControls.findIndex((control:any) => control.id === currentControl.id);
        let nextControlIndex = currentControlIndex+1;
        if(response.controls[nextControlIndex]) {
          setCurrentControl(response.controls[nextControlIndex]);
        } else {
          //get subcategories of current category
          let subcategories = categories.subcategories[currentControl.id_category];
          //find index of next subcategory
          let currentSubcategoryIndex = subcategories.findIndex((subcategory:any) => subcategory.id_subcategory === currentControl.id_subcategory);
          let nextSubcategoryIndex = currentSubcategoryIndex+1;
          if(subcategories[nextSubcategoryIndex]) {
            console.log(subcategories[nextSubcategoryIndex].id_subcategory);
            setCurrentCategory(subcategories[nextSubcategoryIndex].id_category);
            setCurrentSubcategory(subcategories[nextSubcategoryIndex].id_subcategory);
            dataContext.changeCurrentControl('');
            setLoadControl('');
          } else {
            //find index of next category
            let currentCategoryIndex = categories.categories.findIndex((category:any) => category.id_category === currentControl.id_category);
            let nextCategoryIndex = currentCategoryIndex+1;
            if(categories.categories[nextCategoryIndex]) {
              setCurrentCategory(categories.categories[nextCategoryIndex].id_category);
              setCurrentSubcategory('');
              dataContext.changeCurrentControl('');
              setLoadControl('');
            }
          }
        }
      } else {
        setCurrentControl(response.control);
      }

      setCurrentControls(response.controls);
      setSaving(false);
      dataContext.changeShowLoader(false);
      setReloadNavigator(true);
    });
    event.preventDefault();
    return false;
};

  const handleExport = () => {
    exportQuestionnaire(dataContext.currentAssessment).then(response => {
      fileDownload(response, 'questionnaire_'+dataContext.currentAssessment+'_'+moment().format('Y_M_d-h_mm_ss')+'.csv');
    });
  }

  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>{t('Questionnaire')}</Typography></>} 
        actions={[2,3].includes(dataContext.user.id_role) ? [
          {
            label: <Search/>,
            variant: searchOpen ? 'outlinedPrimary':'outlined',
            action: () => {
              setSearchOpen(!searchOpen);
            }
          },
          {
            label: exporting ? t('Exporting...c') : t('Export'),
            variant: 'outlined',
            disabled: exporting ? true : false,
            action: () => {
              handleExport();
            }
          },
            {
              label: saving ? t('Saving...') : t('Save'),
              variant: 'outlined',
              disabled: saving ? true : false,
              action: () => {
                formRef.current?.setAttribute('gotoNext','0');
                formRef.current?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true}));
              }
            },
            {
              label: saving ? t('Saving...') : t('Save and continue'),
              disabled: saving ? true : false,
              action: () => {
                formRef.current?.setAttribute('gotoNext','1');
                formRef.current?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true}));
              }
            }
        ] : []}>
        <Grid container spacing={2}>
            <Grid item xs={7} sx={{paddingRight:4}}>
                <Item>
                {[2,3].includes(dataContext.user.id_role) && currentControl &&
                  <AssessmentControl 
                    key={currentControl?.id_subcategory+currentControl?.id+currentControl?.id_coverage+currentControl?.id_maturity}
                    control={currentControl} 
                    controls={currentControls}
                    selectControl={selectControl}
                    formRef={formRef}
                    handleSubmit={handleSubmit}
                    setReloadNavigator={setReloadNavigator}
                   />}
                {[1].includes(dataContext.user.id_role) && currentControl && categories &&
                  <SubcategoryApproval 
                    categories={categories}
                    key={currentControl?.id_subcategory+currentControl?.id+currentControl?.id_coverage+currentControl?.id_maturity}
                    control={currentControl} 
                    selectControl={selectControl}
                    formRef={formRef}
                    handleSubmit={handleSubmit}
                    setReloadNavigator={setReloadNavigator}
                   />}                   
                </Item>
            </Grid>

            <Grid item xs={5}>
                <Item>
                    {currentControl && categories &&
                    <AssessmentNavigator 
                      key={currentControl?.id_subcategory+currentControl?.id+currentControl?.id_coverage+currentControl?.id_maturity}
                      currentCategory={currentControl.id_category} 
                      currentSubcategory={currentControl.id_subcategory}
                      selectCategory={selectCategory}
                      selectSubcategory={selectSubcategory}
                      categories={categories}
                      searchOpen={searchOpen}
                      />}
                </Item>
            </Grid>
        </Grid>

    </AppLayout>
  );
}

export default Questionnaire;
